module.exports = __webpack_public_path__ + "img/013-vector.aa944c7c.svg";